<template>
  <div class="l-header-panel">
    <div v-on:click="openPanel()" v-bind:class="{isOpen:isOpenPanel}" class="button">
      <div class="button__inner">
        <div class="button__value">
          {{ calcTotal }}<small>円</small>
        </div>
      </div>
    </div>
    <transition>
      <div v-show="isOpenPanel" class="panel">
        <div class="panel__inner">
          <p class="panel__title">売り上げ金額</p>
          <ul class="items">
            <li v-for="item in enableItems" v-bind:key="item.id" class="item">
              <div class="item__name">{{ item.name }}</div>
              <div class="item__value">{{ addComma(item.value) }}<small>円</small></div>
            </li>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
  @import '@/assets/scss/header_panel.scss';

  .button {
    background-image: url($static-path + 'img/factory/btn_sales.png');
  }
</style>

<script>
  export default {
    name: 'Sales',
    props: ['passedTestState'],
    
    data() {
      return {
        isOpenPanel: false,
        items: [
          {
            id: 1,
            name: '洗車',
            value: 10000,
            enable: true,
            passedTests: []
          },
          {
            id: 2,
            name: '12ヶ月点検',
            value: 15000,
            enable: false,
            passedTests: [
              {
                testType: 'study',
                testId: 1
              }
            ]
          },
          {
            id: 3,
            name: '24ヶ月点検',
            value: 22000,
            enable: false,
            passedTests: [
              {
                testType: 'study',
                testId: 2
              }
            ]
          },
          {
            id: 4,
            name: 'スマアシ点検',
            value: 33000,
            enable: false,
            passedTests: [
              {
                testType: 'exam',
                testId: 1
              },
              {
                testType: 'exam',
                testId: 2
              }
            ]
          }
        ]
      }
    },

    computed: {

      calcTotal(){

        let total =  0;

        const items = this.items;

        for (let i = 0; i<items.length; i++) {

          const item = items[i];

          if (item.enable) {
            total += item.value;
          }
        }

        total = this.addComma(total);

        return total;
      },

      enableItems(){

        const items = this.items;
        let enable_items = [];

        for (let i = 0; i<items.length; i++) {

          const item = items[i];

          if (item.enable) {
            enable_items.push(item);
          }
        }

        return enable_items;
      }
    },

    methods: {

      openPanel() {

        if (this.isOpenPanel) {
          this.isOpenPanel = false;
        } else {
          this.isOpenPanel = true;
        }
      },

      addComma(num){

        return String(num).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      }
    },

    watch: {

      // 合格テストリストの値を反映
      passedTestState(val) {

        const items = this.items;
        const items_num = items.length;

        const passed_items = this.$store.getters['PassedTest/items'];
        const passed_num = passed_items.length;

        for (let i=0; i < items_num; i++) {

          const item = items[i];

          const item_tests = item.passedTests;
          const item_tests_num = item_tests.length;

          // テスト項目がある場合のみ
          if (item_tests_num > 0) {

            let is_enable = true;

            // サービス一覧の合格リストと合格テストリストとの比較
            for (let j=0; j < item_tests_num; j++) {

              const item_test = item_tests[j];            

              // 合格リストから該当項目探索
              const target_index = passed_items.findIndex((passed_item) => {
                  return (passed_item.testType === item_test.testType && 
                          passed_item.testId === item_test.testId);
              });

              // 見つからない
              if (target_index < 0) {
                is_enable = false;
              }
            }

            this.items[i].enable = is_enable;
          }
        }
      }
    }
  }

</script>


// WEBPACK FOOTER //
// src/components/Factory/Sales.vue